import { TableToolbar, TableToolbarContent, TableToolbarSearch } from "@carbon/react";
import React, { ChangeEvent, useEffect, useState } from "react";

import { debounceSearchTime } from "src/hooks/useSearch.ts";
import { useT } from "src/internationalization";
import { debounce } from "src/utils/functions.utils.ts";

type CustomerCasesToolbarProps = {
  searchTerm: string;

  handleOnSearchTermChange: (value: string) => void;

  placeholder?: string;
};

export const CustomerCasesToolbar: React.FC<CustomerCasesToolbarProps> = ({
  searchTerm,

  handleOnSearchTermChange,

  placeholder,
}) => {
  const t = useT();
  const [currentSearchTerm, setCurrentSearchTerm] = useState(searchTerm);

  useEffect(() => {
    setCurrentSearchTerm(searchTerm);
  }, [searchTerm]);

  const debouncedSearch = React.useMemo(() => {
    return debounce(handleOnSearchTermChange, debounceSearchTime);
    // We don't want to re-create the debounced function on every render, it makes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setSearchTerm = (value: string) => {
    setCurrentSearchTerm(value);
    debouncedSearch(value);
  };

  const handleSearchInputChange = (event: "" | ChangeEvent<HTMLInputElement>) => {
    if (!event) return;
    setSearchTerm(event.target.value);
  };

  return (
    <>
      <TableToolbar aria-label="data table toolbar">
        <TableToolbarContent>
          <TableToolbarSearch
            placeholder={placeholder || t("general.search.placeholder")}
            onChange={handleSearchInputChange}
            onClear={() => setSearchTerm("")}
            persistent={true}
            value={currentSearchTerm}
          />
        </TableToolbarContent>
      </TableToolbar>
    </>
  );
};
